/*! @pentacode/ui v0.1.0 */
import { _ as e, s as t } from "./guide-layout-CrWsmVuf.js";
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/mark-with-scale-values.js
function n(n, r, i) {
	return {
		initialize: (a) => {
			let o = e(n(a)), s = r === void 0 || o.motion !== void 0 ? o : {
				...o,
				motion: r
			};
			return i === void 0 ? s : t(s, i);
		},
		...r === void 0 ? {} : { motion: r },
		...i === void 0 ? {} : { renderer: i }
	};
}
//#endregion
export { n as t };

//# sourceMappingURL=mark-with-scale-values-BK-kseMB.js.map